var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12","xs":"12","sm":"12"}},[_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }